import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { rValueSchema } from "../../components/common/validations/Validation";
import TextField from "../../components/common/formInput/TextField";
import { options, message } from "../../components/common/utils/message";
import { alert, confirm } from "react-bootstrap-confirmation";
import { useLocation, useNavigate } from "react-router-dom";
import { failed, success } from "../../components/common/Toastify";
import queryString from 'query-string';
import { useDispatch } from "react-redux";
import TextArea from "../../components/common/formInput/TextArea";
import { listRValue, addRValue, updateRValue } from "../../services/rValue";

const RValueForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const [resPayload, setResPayload] = useState();

    useEffect(() => {
        listRValue({ page: 1 }, (data) => { setResPayload(data) }, dispatch);
    }, []);

    const r_value_id = queryString.parse(location.search)
    const get_r_value = resPayload && resPayload.docs.find((item) => item._id === r_value_id.id)

    const initialData = {
        _id: get_r_value ? get_r_value._id : "",
        r_value_name: get_r_value ? get_r_value.r_value_name : "",
        description: get_r_value ? get_r_value.description : "",
    };

    /**
     * @description Function is for add R-Value.
     * @param {object} data 
     */
    const _submitData = (data) => {
        try {
            addRValue(data, result => {
                if (result.status === "SUCCESS" && result.code === 200) {
                    success(result.message)
                    navigate("/rvalue-list")
                } else if (result.status === "ERROR" && result.code === 403) {
                    failed(result.message)
                }
            }, dispatch)
        } catch (e) {
            failed(e)
        }
    };

    /**
     * @description Function is for Update New Roof Type
     * @param {object} data 
     */
    const _updateData = async (data) => {
        try {
            updateRValue(data, result => {
                if (result.status === "SUCCESS" && result.code === 200) {
                    success(result.message);
                    navigate("/rvalue-list")
                } else if (result.status === "ERROR" && result.code === 403) {
                    failed(result.message)
                }
            }, dispatch)
        } catch (e) {
            failed(e)
        }
    };

    /**
     * @description Function is For on Cancel Confirm Box.
     */
    const onCancel = async () => {
        const result = await confirm(message.cancelRValue, options);
        if (result) {
            alert(message.canceledRValueForm);
            navigate("/rvalue-list");
        }
    };

    return (
        <div className="dashboard-inner p-b-0">
            <Formik
                initialValues={initialData}
                enableReinitialize
                validationSchema={rValueSchema}
                onSubmit={(values) => get_r_value ? _updateData(values) : _submitData(values)}
            >
                {(formik) => (
                    <Form>
                        <div className="d-card m-b-25">
                            <div className="d-card-header">
                                <h5 className="d-card-heading">Add R-Value</h5>
                            </div>
                            <div className="d-card-body p-b-0">
                                <div className="form-content">
                                    <div className="f-row alignTop">
                                        <div className="f-33">
                                            <TextField
                                                label="R-Value Name"
                                                name="r_value_name"
                                                value={formik?.values?.r_value_name}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="f-row alignTop">
                                        <div className="f-66">
                                            <TextArea
                                                label="R-Value Description"
                                                name="description"
                                                value={formik?.values?.description}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-card-bottom">
                            <div className="d-card-bottom-cell">
                                <button className="btn btn-blue" type="submit">{get_r_value ? "Edit R-Value" : "Add R-Value"}</button>
                            </div>
                            <div className="d-card-bottom-cell">
                                <button className="btn btn-grey" onClick={onCancel} type="button">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default RValueForm;
